module.exports = __webpack_public_path__ + "static-portal/img/WMS.c6047f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WMS.jpg
// module id = n9tH
// module chunks = 4